import classes from "./Certificates.module.css";
import Heading from "./components/Heading";
import certificates from "../../../data/Certificates";



const Certificates = ({lan}) => {

if(lan === "en"){
  return (
    <section className={classes.container}>
      <Heading marginTop={"-20px"} title={"CERTIFICATES"} />
      <div className={classes.main}>
        <div className={classes.left}>
          <div className={classes.box}>
            <div className={classes.imgContainer}>
              <img
                className={classes.img}
                src={certificates.certificates_left.en[0].src}
                alt={certificates.certificates_left.en[0].title}
                loading="lazy"
              />
            </div>{" "}
            <p>{""} </p>{" "}
          </div>
         <div className={classes.box}>
            <div className={classes.imgContainer}>
              <img
                className={classes.img}
                src={certificates.certificates_left.en[1].src}
                alt={certificates.certificates_left.en[1].title}
                loading="lazy"
              />
            </div>{" "}
            <p>{""} </p>{" "}
          </div>
          <div className={classes.box}>
            <div className={classes.imgContainer}>
              <img
                className={classes.img}
                src={certificates.certificates_left.tr[2].src}
                alt={certificates.certificates_left.tr[2].title}
                loading="lazy"
              />
            </div>{" "}
            <p>{""} </p>{" "}
          </div>
        </div>
        <div className={classes.middle}>
          <div className={classes.box_middle}>
            <div className={classes.imgContainer_middle}>
              <img
                className={classes.img}
                src={certificates.certificates_middle.tr[0].src}
                alt={certificates.certificates_middle.tr[0].title}
                loading="lazy"
              />
            </div>{" "}
            <p>{""} </p>{" "}
          </div>
        </div>
        <div className={classes.right}>
         <div className={classes.box}>
            <div className={classes.imgContainer}>
              <img
                className={classes.img}
                src={certificates.certificates_right.tr[1].src}
                alt={certificates.certificates_right.tr[1].title}
                loading="lazy"
              />
            </div>{" "}
            <p>{""} </p>{" "}
          </div>
          <div className={classes.box}>
            <div className={classes.imgContainer}>
              <img
                className={classes.img}
                src={certificates.certificates_right.tr[0].src}
                alt={certificates.certificates_right.tr[0].title}
                loading="lazy"
              />
            </div>{" "}
            <p>{""} </p>{" "}
          </div>
          <div className={classes.box}>
            <div className={classes.imgContainer}>
              <img
                className={classes.img}
                src={certificates.certificates_right.tr[2].src}
                alt={certificates.certificates_right.tr[2].title}
                loading="lazy"
              />
            </div>{" "}
            <p>{""} </p>{" "}
          </div>
        </div>
      </div>
    </section>
  );
}
  return (
    <section className={classes.container}>
      <Heading marginTop={"-20px"} title={"SERTİFİKALAR"} />
      <div className={classes.main}>
        <div className={classes.left}>
          <div className={classes.box}>
            <div className={classes.imgContainer}>
              <img
                className={classes.img}
                src={certificates.certificates_left.tr[0].src}
                alt={certificates.certificates_left.tr[0].title}
                loading="lazy"
              />
            </div>{" "}
            <p>{""} </p>{" "}
          </div>
         <div className={classes.box}>
            <div className={classes.imgContainer}>
              <img
                className={classes.img}
                src={certificates.certificates_left.tr[1].src}
                alt={certificates.certificates_left.tr[1].title}
                loading="lazy"
              />
            </div>{" "}
            <p>{""} </p>{" "}
          </div>
          <div className={classes.box}>
            <div className={classes.imgContainer}>
              <img
                className={classes.img}
                src={certificates.certificates_left.tr[2].src}
                alt={certificates.certificates_left.tr[2].title}
                loading="lazy"
              />
            </div>{" "}
            <p>{""} </p>{" "}
          </div>
        </div>
        <div className={classes.middle}>
          <div className={classes.box_middle}>
            <div className={classes.imgContainer_middle}>
              <img
                className={classes.img}
                src={certificates.certificates_middle.tr[0].src}
                alt={certificates.certificates_middle.tr[0].title}
                loading="lazy"
              />
            </div>{" "}
            <p>{""} </p>{" "}
          </div>
        </div>
        <div className={classes.right}>
         <div className={classes.box}>
            <div className={classes.imgContainer}>
              <img
                className={classes.img}
                src={certificates.certificates_right.tr[1].src}
                alt={certificates.certificates_right.tr[1].title}
                loading="lazy"
              />
            </div>{" "}
            <p>{""} </p>{" "}
          </div>
          <div className={classes.box}>
            <div className={classes.imgContainer}>
              <img
                className={classes.img}
                src={certificates.certificates_right.tr[0].src}
                alt={certificates.certificates_right.tr[0].title}
                loading="lazy"
              />
            </div>{" "}
            <p>{""} </p>{" "}
          </div>
          <div className={classes.box}>
            <div className={classes.imgContainer}>
              <img
                className={classes.img}
                src={certificates.certificates_right.tr[2].src}
                alt={certificates.certificates_right.tr[2].title}
                loading="lazy"
              />
            </div>{" "}
            <p>{""} </p>{" "}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Certificates;
